import { render } from "./form-header.html?vue&type=template&id=4fe56394&scoped=true&ts=true&external"
import script from "./form-header.ts?vue&type=script&lang=ts&external"
export * from "./form-header.ts?vue&type=script&lang=ts&external"

import "./form-header.scss?vue&type=style&index=0&id=4fe56394&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe56394"]])

export default __exports__